import { init } from '@plausible-analytics/tracker'
import './src/styles/global.css'

init({
  domain: 'yt1s.link',
  endpoint: 'https://pb.ytmp3tube.com/api/event'
})